export const AddressTemplate = {
      "address_line1":"",
      "address_line2":"",
      "city":"",
      "state":"",
      "state_cd":"",
      "zip":"",
      "county":""
    };
